// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5403": "e18e6dcd3191","6863": "454c9f289029","773": "7a7e37acd13a","789": "4b5d38f1058b",}[chunkId] + ".css"
}